import { PieceType, DEFAULT_CONFIG, KEYBINDINGS } from '@game/engine';
import styles from './PieceSelector.module.css';

const PIECE_COLORS: Record<PieceType, string> = {
  I: '#FF6B6B',
  L: '#4ECDC4',
  O: '#FFE66D',
  S: '#95E1D3',
  T: '#C7CEEA',
};

const PIECE_TYPES: PieceType[] = ['I', 'L', 'O', 'S', 'T'];

interface PieceSelectorProps {
  selectedType: PieceType | null;
  currency: number;
  onSelectType: (type: PieceType | null) => void;
  onHoverType: (type: PieceType | null) => void;
}

export function PieceSelector({ selectedType, currency, onSelectType, onHoverType }: PieceSelectorProps) {
  const handlePieceClick = (type: PieceType) => {
    if (currency < DEFAULT_CONFIG.tileConfigs[type].cost) return;
    onSelectType(selectedType === type ? null : type);
  };

  return (
    <div className={styles.selector}>
      <div className={styles.pieceTypes}>
        {PIECE_TYPES.map((type, index) => {
          const shortcut = KEYBINDINGS.selectPiece[index];
          const canAfford = currency >= DEFAULT_CONFIG.tileConfigs[type].cost;
          const isSelected = selectedType === type;
          return (
            <button
              key={type}
              className={`${styles.typeButton} ${isSelected ? styles.active : ''} ${!canAfford ? styles.disabled : ''}`}
              onClick={() => handlePieceClick(type)}
              onMouseEnter={() => onHoverType(type)}
              onMouseLeave={() => onHoverType(null)}
              style={{ backgroundColor: PIECE_COLORS[type] }}
            >
              {type}
              <span className={styles.shortcut}>{shortcut}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
